@if (loadingBrand) {
    <app-wait/>
}
@if (!loadingBrand) {
    <div class="sso-invite-left-side">
        @if (!inviteSent && !inviteSentPreviously) {
        <div [ngClass]="brandKey ? 'branded sso-invite' : 'sso-invite'" (appOnEnter)="sendInvite()">
            <div class="sso-invite-panel-header">
                <div class="sso-invite-header-title">
                    @if (brandKey) {<img src="/images/sircon-logo-white.svg" alt="Sircon, a Vertafore company"> | }Connect
                </div>
            </div>

            <div class="sso-invite-info">
                <app-message-box [content]="errors"></app-message-box>
                <app-message-box level="info" prominent="Welcome to Sircon!">
                    To get connected, complete one of the following:
                    <ol>
                        <li>Use the email your carrier provided below, and we'll send you an email to create an account.</li>
                        <li>If you already have a Sircon account, enter the email you used to create that account.</li>
                    </ol>
                </app-message-box>

                @if (isAgency) {
                    <app-input fieldId="first-name" label="First Name" [(ngModel)]="firstName" type="text"
                               maxlength="25" [errors]="errors.fieldErrors?.firstName" isRequired></app-input>

                    <app-input fieldId="last-name" label="Last Name" [(ngModel)]="lastName" type="text"
                               maxlength="25" [errors]="errors.fieldErrors?.lastName" isRequired></app-input>
                }

                <app-input fieldId="username" label="Email" [(ngModel)]="toEmailAddress" type="email" inputmode="email"
                           [errors]="errors.fieldErrors?.emailAddress" isRequired></app-input>

                <div class="button-row">
                    <app-wait-button (onClick)="sendInvite()" cssClass="btn btn-verty" [waiting]="submitting" label="Start Connection Process"></app-wait-button>
                </div>
            </div>
        </div>
        }

        @if (inviteSent || inviteSentPreviously) {
            <div class="sso-invite-sent">
                <div class="sso-invite-panel-header">
                    <div class="sso-invite-header-title">
                        Connection Pending
                    </div>
                </div>

                <div class="sso-invite-info">
                    <app-message-box [content]="errors"></app-message-box>
                    @if (resendSuccessful) {
                        <app-message-box level="success">The email was successfully resent.</app-message-box>
                    }
                    <div>
                        <h1 class="suif-h3">Almost done! Check your email to create your account and connect to {{ carrierInformation.carrierName }}</h1>
                        <p class="suif-body-copy-small instructions">You should receive an email @if (!inviteSentPreviously) {<span>momentarily </span>}to <span class="email">{{ toEmailAddress }}</span>. If you don't see it, check your spam folder, or
                            <button type="button" class="button-link" (click)="resendInvite()">send another email now.</button>
                            <span>If your email is incorrect, <button type="button" class="button-link" (click)="startOver()">start over with a different email.</button></span>
                        </p>
                    </div>
                </div>
            </div>
        }
        <div class="walkup-help">
            @if (carrierInformation) {
                <a target="_blank" href="{{brandedWalkupHelpUrl()}}">Sircon Help & Support</a>
            }
        </div>
    </div>
}
@if (brandKey && (!inviteSent || loadingBrand)) {
    <div class="brand-panel">
        <app-brand-information (loadingBrandEvent)="loadingBrandEvent($event)"
                               (loadingErrorEvent)="loadingBrandErrorEvent()"
                               (carrierInformationEvent)="carrierInformationEvent($event)"
                               [messageOverride]="'Sircon helps you maintain insurance licensing and compliance easily by ' +
                            'giving you direct access to your carrier partners and the states you do business in, all in one place.'">
        </app-brand-information>
    </div>
}
